export { default } from "./deprecatedPropType.js";